angular.module("SettingsApp").factory("ListOfAllApplicationsFactory", ["$resource", function ($resource) {
    return $resource("/api/v1.0/dashboard/all_applications", {}, {});
}]);